import { combineValidators, composeValidators, isRequired } from 'revalidate';

import { isValidEmail } from 'utils/validators';

export default combineValidators({
  email: composeValidators(isValidEmail, isRequired)('Email'),
});
